import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
// import moment from 'moment'
import { format } from 'date-fns'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Button from 'components/Button'

import {
  IconProgressDraft, IconProgressUploaded, IconProgressSubmitted, IconProgressAgreed, IconProgressInterim,
  IconProgressInterimSubmitted, IconProgressInterimAgreed, IconProgressFinal, IconProgressFinalSubmitted, IconProgressFinalAgreed,
} from 'icons'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('../PartnerPlanList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class PartnerPlanList extends Component {
  static propTypes = {
    handleSelectedPlan: PropTypes.func.isRequired,
    header: PropTypes.string,
    partnerPlanItems: PropTypes.instanceOf(Array),
    role: PropTypes.string,
  }
  static defaultProps = {
    partnerPlanItems: {},
    header: '',
    role: '',
  }
  renderCols = () => {
    return (
      <tr>
        <th className={classnames(styles.columns.name, headerStyles)}>
          Name
        </th>
        <th className={classnames(styles.columns.fy, headerStyles)}>
          FY
        </th>
        <th className={classnames(styles.columns.status, headerStyles)}>
          Status
        </th>
        <th className={classnames(styles.columns.lastupdate, headerStyles)}>
          Last updated
        </th>
        <th className={classnames(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.partnerPlanItems.length ? (
      this.props.partnerPlanItems.map(pp => (
        <tr className={styles.base} key={pp.rowId}>
          <td className={styles.columns.name}>{pp.name}</td>
          <td className={styles.columns.fy}>{pp.year}</td>
          <td className={styles.columns.status}>
            {pp.planStatus === constants.PARTNERPLAN.STATUS.DRAFT && <IconProgressDraft />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED && <IconProgressUploaded />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED && <IconProgressSubmitted />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.AGREED && <IconProgressAgreed />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT && <IconProgressInterim />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED && <IconProgressInterimSubmitted />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED && <IconProgressInterimAgreed />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT && <IconProgressFinal />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED && <IconProgressFinalSubmitted />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED && <IconProgressFinalAgreed />}
            {pp.planStatus === constants.PARTNERPLAN.STATUS.EXEMPT && <div className={styles.columns.tooltip}>{pp.planStatus}{`: ${pp.adminComments}`}</div>}
            {pp.planStatus !== constants.PARTNERPLAN.STATUS.DRAFT && pp.planStatus !== constants.PARTNERPLAN.STATUS.UPLOADED &&
              pp.planStatus !== constants.PARTNERPLAN.STATUS.SUBMITTED && pp.planStatus !== constants.PARTNERPLAN.STATUS.AGREED &&
              pp.planStatus !== constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT && pp.planStatus !== constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED &&
              pp.planStatus !== constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED && pp.planStatus !== constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT &&
              pp.planStatus !== constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED && pp.planStatus !== constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED && 
              pp.planStatus !== constants.PARTNERPLAN.STATUS.EXEMPT && pp.planStatus}
          </td>
          <td className={styles.columns.lastupdate}>{pp.lastModifiedDate ? `${format(new Date(pp.lastModifiedDate), constants.DATE_FORMAT.PARTNER_PLAN_LIST)} by ${pp.lastModifiedBy}` : ''}</td>
          <td>
            {pp.planStatus !== constants.PARTNERPLAN.STATUS.EXEMPT &&
            <Button
              onClick={() => {
                const partnerPlan = {
                  Name: pp.name,
                  EmployeeId: pp.employeeId,
                  LoginName: pp.loginName,
                  Role: this.props.role,
                  PlanYear: pp.year,
                  PlanStatus: pp.planStatus,
                  CPEmail: pp.cpEmail,
                  CPEmpId: pp.cpEmpId,
                  MLEmail: pp.mlEmail,
                  MLEmpId: pp.mlEmpId,
                  BLEmail: pp.blEmail,
                  BLEmpId: pp.blEmpId,
                  CILEmail: pp.cilEmail,
                  CILEmpId: pp.cilEmpId,
                  BUCOOEmail: pp.bucooEmail,
                  BUCOOEmpId: pp.bucooEmpId,
                  OPLEmail: pp.oplEmail,
                  OPLEmpId: pp.oplEmpId,
                  OLEmail: pp.olEmail,
                  OLEmpId: pp.olEmpId,
                  CEOEmail: pp.ceoEmail,
                  CEOEmpId: pp.ceoEmpId,
                }
                this.props.handleSelectedPlan(partnerPlan)
              }}
              type="flat"
            >
              VIEW
            </Button> }
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noPartnerPlans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
      </div>
    )
  }
}

export default PartnerPlanList



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/PartnerPlan/PartnerPlanList.js